let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hR71v")).then(() => parcelRequire('ehwUR'));